import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDHeadlineText, FDTitleText, FDBodyText,
} from '@facet-wealth/design';
import { withComponentArray } from 'Helpers/MetaOverride';


export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withComponentArray(FDTitleText),
    _customProps: {
      color: 'textSecondary',
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => withComponentArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride('gainLossAmount', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);
